(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('IssueSignificanceDetailController', IssueSignificanceDetailController);

    IssueSignificanceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'IssueSignificance', 'Company'];

    function IssueSignificanceDetailController($scope, $rootScope, $stateParams, previousState, entity, IssueSignificance, Company) {
        var vm = this;

        vm.issueSignificance = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:issueSignificanceUpdate', function(event, result) {
            vm.issueSignificance = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
